(function () {
  let PT242_ADDING_TO_CART = false;
  function closeAllPopups() {
    document.querySelectorAll(".PT242__OptionWidget").forEach(popup => {
      popup.style.display = "none";
    });
    document.querySelectorAll(".PT242__Overlay").forEach(overlay => {
      overlay.style.display = "none";
    });
  }

  function updateButtonPrice(optionWidget, price) {
    const priceEl = optionWidget.querySelector(".PT242__OptionWidget--ButtonPrice");
    if (priceEl && price) priceEl.textContent = price;
  }
  document.addEventListener("click", function (e) {
    const addToCartBtn = e.target.closest(".PT242__Button--addToCart");
    if (!addToCartBtn) return;

    e.preventDefault();

    const card = addToCartBtn.closest(".ProductItem");
    if (!card) return;

    const optionWidget = card.querySelector(".PT242__OptionWidget");
    const overlay = card.querySelector(".PT242__Overlay");

    if (!optionWidget || !overlay) return;

    closeAllPopups();
    optionWidget.style.display = "block";
    overlay.style.display = "block";
  });

  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".PT242__OptionWidget--Close") ||
      e.target.classList.contains("PT242__Overlay")
    ) {
      closeAllPopups();
    }
  });
  document.addEventListener("click", function (e) {
    const toggleOneTime = e.target.closest(".pt_413_toggle_input_one_time");
    const toggleSubscription = e.target.closest(".pt_413_toggle_input_subscription");
    const switchToSubCTA = e.target.closest(".pt_413_onetime_left_lower_cta");

    if (!toggleOneTime && !toggleSubscription && !switchToSubCTA) return;

    const optionWidget = e.target.closest(".PT242__OptionWidget");
    if (!optionWidget) return;

    const onetimeOption = optionWidget.querySelector(".PT242__OptionWidget--Onetime");
    const subscriptionOption = optionWidget.querySelector(".PT242__OptionWidget--Subscription");
    const onetimeWrapper = optionWidget.querySelector(".pt_413_onetime_wrapper");
    const subscriptionWrapper = optionWidget.querySelector(".pt_413_subscription_wrapper");

    if (toggleOneTime || switchToSubCTA) {
      subscriptionOption?.classList.add("PT242__OptionWidget--Active");
      onetimeOption?.classList.remove("PT242__OptionWidget--Active");
      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      updateButtonPrice(optionWidget, subscriptionOption?.getAttribute("optionprice"));
    }

    if (toggleSubscription) {
      onetimeOption?.classList.add("PT242__OptionWidget--Active");
      subscriptionOption?.classList.remove("PT242__OptionWidget--Active");
      subscriptionWrapper?.classList.add("pt_413_hidden");
      onetimeWrapper?.classList.remove("pt_413_hidden");
      updateButtonPrice(optionWidget, onetimeOption?.getAttribute("optionprice"));
    }
  });
  document.addEventListener("click", function (e) {
    const confirmBtn = e.target.closest(".PT242__OptionWidget--Button");
    if (!confirmBtn) return;

    e.preventDefault();

    // 🔒 Prevent duplicate adds
    if (PT242_ADDING_TO_CART) return;
    PT242_ADDING_TO_CART = true;

    const optionWidget = confirmBtn.closest(".PT242__OptionWidget");
    const card = confirmBtn.closest(".ProductItem");
    const overlay = card?.querySelector(".PT242__Overlay");

    if (!optionWidget || !card) {
      PT242_ADDING_TO_CART = false;
      return;
    }

    const variantId = confirmBtn.getAttribute("data-variant-id");
    if (!variantId) {
      console.error("No variant ID found");
      PT242_ADDING_TO_CART = false;
      return;
    }

    const subscriptionOption =
      optionWidget.querySelector(".PT242__OptionWidget--Subscription");
    const subscriptionSelect =
      optionWidget.querySelector(".PT242__OptionWidget--Subscription--Options");

    const isSubscription =
      subscriptionOption?.classList.contains("PT242__OptionWidget--Active");

    const sellingPlanId =
      isSubscription && subscriptionSelect?.value
        ? subscriptionSelect.value
        : null;

    confirmBtn.classList.add("is-loading");
    confirmBtn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: {
            _no_discount: "true"
          },
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
        }]
      })
    })
      .then(res => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: Number(variantId),
            quantity: 1
          }
        }));
        document.querySelector(".cart_dr")?.click();
        optionWidget.style.display = "none";
        overlay && (overlay.style.display = "none");
      })
      .catch(err => {
        console.error("Add to cart error:", err);
        alert("Sorry, could not add product to cart.");
      })
      .finally(() => {
        PT242_ADDING_TO_CART = false;
        confirmBtn.classList.remove("is-loading");
        confirmBtn.disabled = false;
      });
  });
})();